import styled from "styled-components";

export const FloatingWrap = styled.div`
  position: fixed;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  @media (min-width: 769px) {
    bottom: 16px;
  }
`;

export const Switcher = styled.div`
  display: inline-flex;
  background: #f6f3e9;
  border: 1px solid #e6dec7;
  border-radius: 999px;
  padding: 3px;
  gap: 4px;
`;

export const Btn = styled.button`
  font-size: 12px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  cursor: pointer;
  background: ${({ $active }) => ($active ? "#d4af37" : "transparent")};
  color: ${({ $active }) => ($active ? "#111" : "#6b6250")};
  transition: all 0.2s ease;

  &:hover {
    filter: brightness(0.98);
  }
`;
